import Slider from './Slider';
new Slider();